export default __webpack_public_path__ + "static/media/cart-filled.1e37bcd3.png";